export const home = {
  welcome: {
    title: "Welcome to Lyder Talk",
    subtitle: "Your daily practice space for speaking a new language with confidence.",
    featOneTitle: "Practice speaking",
    featOneDesc: "Pick a topic, generate questions, and practice out loud with instant feedback.",
    featTwoTitle: "Build streaks",
    featTwoDesc: "Practice daily to keep your streak alive, earn XP, and level up.",
    featThreeTitle: "Track progress",
    featThreeDesc: "Save vocabulary, review with spaced repetition, and climb the leaderboard.",
    maybeLater: "Maybe later",
    startTour: "Start tour",
  },
  hero: {
    welcomeTitle: "Welcome to Lyder Talk",
    description: "Pick a topic, practise speaking, and build a daily streak.",
    createTopic: "Create Topic",
    browseTopics: "Browse Topics",
    randomQuestion: "Roll & Talk",
    /** Time-of-day salutations, keyed by the hour bucket in `HomeHero`. */
    greeting: {
      lateNight: "Burning the midnight oil",
      morning: "Good morning",
      afternoon: "Good afternoon",
      evening: "Good evening",
      night: "Welcome back",
    },
    /** Fallback salutation for a guest with no display name. */
    guestName: "friend",
    /** Stand-in for a signed-in learner whose display name is empty. */
    defaultName: "there",
  },
  today: {
    label: "Today",
    dueForReview: "Due for review",
    wordsReady_one: "word ready",
    wordsReady_other: "words ready",
    streak: "Streak",
    day_one: "day",
    day_other: "days",
    weeklyXp: "Weekly XP",
    weeklyXpAria: "Weekly XP progress",
    ctaReview_one: "Review {{count}} word",
    ctaReview_other: "Review {{count}} words",
    ctaStartStreak: "Start today's practice",
    ctaKeepPractising: "Keep practising",
    startStreakHint: "Start a streak that sticks",
    aboutMinutes: "about {{count}} min",
  },
  continue: {
    title: "Continue practising",
    empty: "Nothing in progress yet",
    emptyDescription: "Pick a topic and your work will show up here.",
    browse: "Browse topics",
    practised: "You practised",
    studied: "You studied",
    created: "You created",
    lastStudied: "Last studied {{when}}",
    lastPractised: "Last practised {{when}}",
  },
  discover: {
    trending: "Trending",
    new: "New",
    trendingTitle: "Popular this week",
    newTitle: "Fresh from the community",
    collections: "Collections",
    collectionsTitle: "Curated sets",
    empty: "No topics here yet",
    /** Placeholder for a session whose topic title never rendered. */
    unknownTopic: "Unknown topic",
  },
  topicOfDay: {
    title: "Topic of the day",
    curatedDaily: "Curated daily",
    openEnded: "Open-ended conversation",
    practise: "Practise this",
    view: "View",
  },
  quote: {
    label: "Quote of the day",
    loading: "Loading today's quote",
  },
  emptyState: {
    eyebrow: "Get started",
    title: "Start speaking practice in 3 steps",
    titleAuthenticated: "Your dashboard is ready",
    description:
      "Create an account, pick a topic, and start a 5-minute speaking session. No card required.",
    descriptionAuthenticated:
      "Pick a topic below to start your first session. We'll track your progress and build a streak from there.",
    stepLabel: "Step {{step}}",
    cta: "Browse topics",
    quickPractice: "Quick Practice",
    getStartedFree: "Get started free",
    steps: {
      browse: "Browse topics",
      browseDescription: "Hundreds of curated topics across business, travel, lifestyle, and more.",
      pick: "Pick a topic",
      pickDescription: "Filter by category, level, or popularity. Save favorites to your library.",
      practise: "Practice speaking",
      practiseDescription: "Record yourself answering questions. Build a streak and track progress over time.",
    },
  },
  studyingNow: {
    label: "Studying now",
    live: "Live",
    // Flat with the i18next plural separator (`_`), not nested as
    // `learners.one`. i18next looks for `<id>_one` / `<id>_other`; a dotted
    // key is read as a literal nested name and never gets the count
    // interpolation, so it would silently render the key itself.
    learners_one: "{{total}} learner is practising",
    learners_other: "{{total}} learners are practising",
    topicLearners_one: "{{count}} learner",
    topicLearners_other: "{{count}} learners",
    subjects_one: "{{total}} subject",
    subjects_other: "{{total}} subjects",
    join: "Join room",
    moreRooms_one: "+{{count}} room",
    moreRooms_other: "+{{count}} rooms",
    anonymousTopic: "Studying",
    learnersShort_one: "{{total}} learner",
    learnersShort_other: "{{total}} learners",
    moreSubjects_one: "+{{count}} subject",
    moreSubjects_other: "+{{count}} subjects",
    showLess: "Show less",
  },
  loginPrompt: {
    title: "Sign in to save your progress",
    description: "Your streak, vocabulary and recordings follow your account.",
    cta: "Sign in",
    secondary: "Browse as guest",
  },
} as const;